import type { Dispatch, ReactNode, SetStateAction } from 'react';

import { Divider } from '../../assets/Divider/Divider';
import { Badge } from '../../components/Badge/Badge';
import { styled } from '../../stitches.config';
import { HStack } from '../../utilities/Stack/HStack';

export interface StepProps {
  label: ReactNode;
  onClick?: () => void;
}

export interface StepsProps {
  steps: StepProps[];
  activeIndex: number;
  setActiveIndex?: Dispatch<SetStateAction<number>>;
}

const StepsDivider = styled(Divider, {
  flex: '0 1 auto',
  width: '$40',
});
StepsDivider.displayName = 'StepsDivider';

export function Steps({ steps, activeIndex, setActiveIndex }: StepsProps) {
  return (
    <HStack spacing={4} align="center">
      {steps.map((step, index) => (
        <>
          {index > 0 && (
            <StepsDivider appearance="thick" variant={index <= activeIndex ? 'brand' : 'neutral'} />
          )}
          <Badge
            variant={index <= activeIndex ? 'brand' : 'neutral'}
            ends="pill"
            onClick={step?.onClick ?? setActiveIndex ? () => setActiveIndex?.(index) : undefined}
          >
            {step.label}
          </Badge>
        </>
      ))}
    </HStack>
  );
}
